import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AXIOS } from '../api'
import { Link } from 'react-router-dom'
import Switch from "react-switch"
import parser from 'react-html-parser'

import { setFiltrage, setLoading, setFetch } from '../redux/actions'
import { Box, Text, Icons, Icon, PictureItem, Button } from './common/Themes'

const GestionOffres = () => {

    const dispatch = useDispatch()
    const { activites, offres } = useSelector(state => state.fetch)
    const { filtrage: { aidActive, oidActive }, fetch } = useSelector(state => state.config)

    const [update, setUpdate] = useState(false)

    const [offresFill, setOffresFill] = useState([])
    const [aidFil, setAidFil] = useState()

    useEffect(() => {
        setOffresFill(offres)
        setAidFil(activites[0]?.aid)
    }, [activites, offres, setOffresFill])

    useEffect(() => {
        if (aidActive) setOffresFill(offres.filter(({ aid }) => aid == aidFil))
        else setOffresFill(offres)
    }, [aidFil, aidActive])

    const deleteHandler = async oid => {
        try {
            dispatch(setLoading(true))
            await AXIOS.delete(`/api/v1/offres/${oid}`)
            setUpdate(!update)
            dispatch(setFetch(!fetch))
            dispatch(setLoading(false))
        } catch (error) {
            console.log(error)
        }
    }

    const gestionItem = (oid, aid, classement, title, image, color) => {
        const activite = activites.filter(activite => activite.aid === aid)[0]
        return (
            <Box key={oid}>
                {/* <input style={{ margin: '0 1rem' }} type="checkbox" id="xxx" name="xxx"></input> */}
                <div style={{ margin: '0 1rem', width: '1.3rem' }}></div>
                <PictureItem image={`url(${process.env.REACT_APP_SITE_MARCHAND}${image}), url('/img/default_image.png')`}>&nbsp;</PictureItem>
                <Text color={activite?.color1} style={{ width: '14rem' }}>{classement}</Text>
                <Text color={activite?.color1}>{parser(title)}</Text>
                <Text color={activite?.color1}>{activite?.name}</Text>
                <div className="gestion__text"></div>
                <div style={{ marginLeft: 'auto' }}>
                    <Link to={`/offre/${oid}`}>
                        <Icons color={activite?.color1}>
                            <use xlinkHref="/img/sprite.svg#icon-edit"></use>
                        </Icons>
                    </Link>
                    <Icons onClick={() => deleteHandler(oid)} color={activite?.color1}>
                        <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                    </Icons>
                </div>
            </Box>
        );
    }

    const handleChange = e => setOffresFill(offres.filter(({ name }) => name?.toLocaleLowerCase().includes(e.target.value?.toLocaleLowerCase())))

    return (
        <>
            <div className="gestion">
                <div className="gestion__header">
                    <h4 className="gestion__title">Gestion offres</h4>
                    <h5 className="gestion__total">{offresFill.length} Total</h5>

                    <div style={{ marginLeft: 'auto', display: 'flex', position: 'relative' }}>
                        <input name="search" onChange={handleChange} className="gestion__input" placeholder="Rechercher" />
                        <Icons color="#B0BAC9" style={{ margin: '1rem', position: 'absolute', right: '1rem' }}>
                            <use xlinkHref="/img/sprite.svg#icon-search"></use>
                        </Icons>
                    </div>

                </div>
                <div className="gestion__container">
                    <h4 className="gestion__subTitle">Filtrage des offres</h4>
                    <div className="gestion__filtrage">
                        <div className="gestion__filtrageWrapper">
                            <Switch checked={aidActive} onColor="#45B755" offColor="#ED292D" onChange={() => dispatch(setFiltrage({ aidActive: !aidActive, oidActive }))} />
                            <div className="form__inputbox gestion__inputbox">
                                <label htmlFor="birthday" className="form__label">Activité</label>
                                <select name="aid" onChange={e => setAidFil(e.target.value)} className="form__input" style={{ padding: '0 1rem' }}>
                                    {activites.map(({ aid, name }) => <option className="form__dropdown" key={aid} value={aid}>{name}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>

                </div>
                <Button to='/offre' color={'#FF5C00'} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Icons color={'#fff'} style={{ margin: '0 1rem 0 0', width: '16px' }}>
                        <use xlinkHref="/img/sprite.svg#icon-plus"></use>
                    </Icons>
                    Nouveau
                </Button>
                <div className="gestion__content">
                    <div className="gestion__listheader">
                        <div className="gestion__headerItem" style={{ width: '14.4rem' }}></div>
                        <div className="gestion__headerItem" style={{ width: '14.4rem' }}>Classement</div>
                        <div className="gestion__headerItem">Nom</div>
                        <div className="gestion__headerItem">Activité</div>
                        <div className="gestion__headerItem"></div>
                    </div>
                    <div className="gestion__list">
                        {offresFill.map(({ oid, aid, classement, name, image, color }) => gestionItem(oid, aid, classement, name, image, color))}
                    </div>
                    <Link to='/offre' style={{ alignSelf: 'center' }}>
                        <Icon color={'#FF5C00'} style={{ marginBottom: '0' }}>
                            <use xlinkHref="/img/sprite.svg#icon-plus-alt"></use>
                        </Icon>
                    </Link>
                </div>
            </div>
        </>
    );
}

export default GestionOffres